import React from "react";

import LogoImage from "../../assets/images/logo.svg";

const Logo: React.FC = () => {
  return (
    <div className="flex items-center gap-2">
      <img src={LogoImage} alt="logo" className="w-16" />
      <h1 className="hidden md:block uppercase font-logo font-medium text-2xl">
        goals
      </h1>
    </div>
  );
};

export default Logo;
